module.exports = __webpack_public_path__ + "img/blessings.6abe425d.svg";